// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see EndOfOnboardingCheckLockedRegionEvent
 */
export var EndOfOnboardingCheckLockedRegion = function (_a) {
    var lockedRegion = _a.lockedRegion;
    return ({
        name: "EndOfOnboarding Check LockedRegion",
        parameters: {
            cdf_entity: "EndOfOnboarding",
            cdf_action: "Check",
            locked_region: lockedRegion !== undefined && lockedRegion !== null ? lockedRegion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
